(($) => {
  $(document).on("DOMContentLoaded", async () => {
    if (siteData.isLoggedIn) document.body.classList.add("logged-in");
    else document.body.classList.add("logged-out");

    await Promise.all([require("./woocommerce"), require("./navbar")]);
  });
})(jQuery);
